import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "What is search engine advertising, and how does it benefit my business?",
    answer: `<p>Search engine advertising places paid ads on search engine results pages, targeting specific keywords to drive relevant traffic. It offers quick visibility and measurable ROI, ideal for lead generation.</p>`,
  },
  {
    question: "How can a search engine marketing agency improve my ROI?",
    answer: `<p>A search engine marketing agency optimizes ad campaigns by managing bids, keywords, and ad copy, focusing on high-performing strategies to maximize conversions and minimize costs.</p>`,
  },
  {
    question: "What should I look for in a search agency marketing company?",
    answer: `<p>Choose a search agency marketing company with a solid track record, industry knowledge, and transparent reporting. They should provide customized strategies and continuous optimization to meet your goals.</p>`,
  },
  {
    question:
      "What are the key components of effective search engine marketing services?",
    answer: `<p>Effective SEM services include keyword research, ad creation, bid management, and performance tracking, all focused on reaching the right audience and driving conversions.</p>`,
  },
  {
    question: "How much do SEM services cost?",
    answer: `<p>Search engine marketing services costs vary by industry and ad spend. Expect to pay a management fee plus ad budget, with campaigns often starting from a few thousand dollars per month.</p>`,
  },
  {
    question:
      "How long does it take to see results from search engine marketing?",
    answer: `<p>Initial results can be seen within days, but significant ROI improvements typically occur over weeks to months as campaigns are optimized.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Search Engine Marketing FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
